
import { defineComponent, PropType, reactive } from 'vue'

// @components
import NewModal from '@/common/new-components/NewModal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

// @types
import { TakeOrder } from '@/new-services/types/takes'

// @validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// @composable
import { useFormData } from '@/common/composable/useFormData'

export default defineComponent({
    components: {
        NewModal,
        FileReader,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Object as PropType<TakeOrder>,
            required: true,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const { getFormData } = useFormData()

        const state = reactive({
            is_loading: false,
        })

        const payload = reactive({
            productFiles: [] as File[],
            shortcomingFiles: [] as File[],
        })

        const validation$ = useVuelidate(
            {
                productFiles: { required },
                shortcomingFiles: { required },
            },
            payload
        )

        const onSubmit = () => {
            if (props.loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            emit('submit', getFormData({ orderId: props.order.orderId, ...payload }))
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        return {
            state,
            payload,
            //
            validation$,
            //
            onSubmit,
            onCancel,
        }
    },
})
